import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { UPDATE_CARDNAME, STATUS_SUCCESS_CODE, CAN_CREATE_SAVINGS_ACC } from '../../../network/URLConstants';
import { GetApiHeadersWithBearer, GetRequest, PostRequest } from '../../../network/NetworkUtils';
import LineBreaks, { addLineBreaks, displayErrorMessage, displaySuccessMessage, MoreServices, retrieveData } from '../../../utils';
import check_img from '../../../assets/images/check_3x.png'
import beneficiarysaving from '../../../assets/images/beneficiarysaving.png';
import ClimbImg from '../../../assets/images/illo-climb.png';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import FooterContent from '../../../components/CustomComponents/Footer';
import HomeLayout from '../../../components/Layout/HomeLayout';
import HomeHeader from '../../../components/CustomComponents/HomeHeader';
import DynamicCard from '../../../components/CustomComponents/DynamicCard';
import Loader from '../../../components/CustomComponents/Loader';
import CustomAlertModel from '../../../components/CustomComponents/CustomAlertModel';
import logFirebaseEvents from '../../../components/LogFirebaseEvents';
import { width } from '../../../components/CustomComponents/DynamicCard/DynamicCardStyles';
import Approved from '../../../assets/images/Approvedd.png'
import KudzuLogo from '../../../assets/images/kudzuLogo.png'
import Ach_acces from '../../../assets/kudzu-plus-images/ach_acces.png'
import KudzuPluseLogo from '../../../assets/kudzu-plus-images/KudzuPluseLogo.png';
import SavingsInteresrRate from '../../../assets/kudzu-plus-images/SavingsInteresrRate.png'
import CoveredbyKudzuplus from '../../../assets/kudzu-plus-images/CoveredbyKudzuplus.png'
import Frame from '../../../assets/kudzu-plus-images/Frame.png'
import ATM_small from '../../../assets/kudzu-plus-images/ATM_small.png'
import Security from '../../../assets/kudzu-plus-images/securityIcon.png'
import Checkbox from '../../../assets/kudzu-plus-images/checkbox.png'
import GradientArrow from '../../../assets/kudzu-plus-images/gradientArrow.png'
import CustomModalPlus from '../../helpers/customModalPlus';
import MemnershipEnrollmentScreens from '../membershipEnrollmentScreens';
import CustomCarousel from '../../helpers/customCarousel';
import CardHeading from '../../../components/CustomComponents/CardHeading';
import { appTheme, getUserMembership } from '../../../helpers/utils/Utils';
import ProgressBar from '../../../components/CustomComponents/ProgressBar';
import Handle from 'rc-slider/lib/Handles/Handle';
import { PAID_PROMO_KEY } from '../../../network/URLConstants';
import ComparisonOffer from '../Comparison offer';

const ManageMembershipKudzuPlus = ({ transactionDatas, onViewAllClick, viewAll , isSignUpAccept }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation()
    const { t } = useTranslation(); // Hook to access translation functions
    const cards = useSelector(state => JSON.parse(state.userCards));
    const savingsCardAvailable = useSelector(state => state.savingsAccontAvailable);
    const accessTokenToApi = useSelector(state => state.accessToken);
    const [editClicked, setEditClicked] = useState(false);
    const [showCheckImage, setshowCheckImage] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue)

   

    const selectedItem = cards?.[0]
    const [newName, setNewName] = useState((selectedItem != undefined && selectedItem != null) ? selectedItem.NickName : "");

    const [loading, setLoading] = useState(false);
    const [infoMessage, setinfoMessage] = useState('');
    const [responseCode, setResponseCode] = useState('');
    const HighlightMsgStyles = "sm:w-auto w-[253px] font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal text-[#2965FB] cursor-pointer pointer-events-none";
    const HeaderMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";
    const SubHeaderMsgStyles = "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none";
    const summaryParagraphStyles = "font-hanken-grotesk modal-title text-white lg:text-[12px] md:text-[10px] sm:text-[6px] text-[8px] font-normal cursor-pointer pointer-events-none";
    const HeaderMsgStylesForPlus = "w-[240px] md:w-[399px] font-serif-pro text-white modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";
    const SubHeaderMsgPlusStyles = "sm:w-[399px] font-hanken-grotesk modal-title mt-[17px] md:text-[16px] sm:text-[14px] text-[16px] sm:leading-[27px] lg:leading-[30px] md:leading-[30px] leading-[30px] font-[400] cursor-pointer text-white";
    const dynamicfooterStyles =  "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]";

    const [highlightMsg, setHighlightMsg] = useState('')
    const [headerMsg, setheaderMsg] = useState('')
    const [subHeaderMsg, setSubHeaderMsg] = useState('')
    const [btn1Exists, setBtn1Exists] = useState(false)
    const [btn2Exists, setBtn2Exists] = useState(false)
    const [btn1Text, setBtn1Text] = useState(false)
    const [btn2Text, setBtn2Text] = useState('')
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
    const [footerMsg, setFooterMsg] = useState('');
    const [showModel, setShowModel] = useState(false);
    const [modelImage, setModelImage] = useState('')
    const [savingsTheme, setSavingsTheme] = useState(false);
    const [isBorderNone, setisBorderNone] = useState(true);
    const [isSubFooter, setIsSubFooter] = useState(false);
    const [summaryParagraph, setSummaryParagraph] = useState('');
    const [opacityValueLow, setOpacityValueLow] = useState(false);
    const [showPlusModal, setShowPlusModal] = useState(false);
    const [comparisonScreen, setComparisonScreen] = useState('');
    const [fullWidth, setFullWidth] = useState(false);
    const [footerButtonEnable, setFooterButtonEnable] = useState(false);
    const [gradientButton, setGradientButton] = useState(false);
    const [largeImage, setLargeImage] = useState(false);
    const [allButtonsDisable, setAllButtonsDisable] = useState(false);
    const [btn1TextColor, setBtn1TextColor] = useState("");
    const [footerText, setFooterText] = useState("");
    

    const [carousel, setCarousel] = useState('');
    const [btn1BgColor, setBtn1BgColor] = useState("");
    const [showCarouselScreenShow, setShowCarouselScreensShow] = useState(false);
    const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
    const userMembershipData = getUserMembership(loggedResponse)
    const currentpath = useLocation()




    const textArray = [
        { paragraph: t('Access_Direct_Deposite_Text'), imageUrl: require('../../.././assets/images/Check_Green.png') },
        { paragraph: t('Annual_Percentage_Text'), imageUrl: require('../../.././assets/images/Check_Green.png') },
        { paragraph: t('Additional_Exclusive_text'), imageUrl: require('../../.././assets/images/Check_Green.png') },
        { paragraph: t('Withdrawal_text'), imageUrl: require('../../.././assets/images/Check_Green.png') }
    ];
    const cardTextArray = [
        { paragraph: t('APL_text'), imageUrl: require('../../.././assets/images/CheckDarkBlue.png') },
        { paragraph: t('AllPoint_text'), imageUrl: require('../../.././assets/images/CheckDarkBlue.png') },
        { paragraph: t('Access_text'), imageUrl: require('../../.././assets/images/CheckDarkBlue.png') },
    ];



    const handleRevertClick = () => {
        setinfoMessage('');
        setEditClicked(false);
    };



    const subComponent = () => {
        return (
            <div className=' flex justify-start items-start'>
                <p className="font-hanken-grotesk font-semibold sm:font-[500] sm:text-[14px] md:text-[20px] text-[16px] md:leading-[30px] leading-[24px]">{t("pl_contact_customer")}<span className="text-[#2965FB] cursor-pointer" onClick={
                    () => window.open("https://www.kudzumoney.com/contact-us", '_blank')}>{t("support_email")}</span>{t("for_access")}</p>
            </div>
        )
    }


    useEffect(() => {
    }, [cards, dispatch]);

    const closeCustomAlertModal = () => {

        setShowModel(false);
    }

    const onAcptBtnClick = async () => {
        setShowModel(false)
        if (btn1Text == t("enroll")) {
            navigate('/SetupSavingsAccount')
            dispatch({ type: 'SSN_SCREEN_THROUGH', payload: { ssnScreenThrough: t('account_services_savings_enrollment') } });
        } else if (btn1Text == t('home')) {
            navigate('/home')
        }

    }
    const onCancelBtnClick = () => {
        setShowModel(false)
        showAlertModal(true, '', t('savings_no_problem_title'), t('via_account_services_title'), true, false, t('okay_got_it'), '', true, beneficiarysaving, true, true);
    }
    const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, savingsTheme, isBorderNone, isSubFooter) => {
        setShowModel(showModel)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setSavingsTheme(savingsTheme)
        setisBorderNone(isBorderNone)
        setIsSubFooter(isSubFooter)
    }


    const showAlertModalPlus = (showPlusModal, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists,
        btn1Text, btn2Text, btn1TypeAcpt, modelImage, carousel, isBorderNone, btn1BgColor,
        summaryParagraph, opacityValue, comparisonScreen, fullWidth, footerButtonEnable,
        gradientButton, largeImage, allButtonsDisable,btn1TextColor,footerText) => {
        setShowPlusModal(showPlusModal)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setBtn1Exists(btn1Exists)
        setBtn1Text(btn1Text)
        setCarousel(carousel)
        setisBorderNone(isBorderNone)
        setBtn1BgColor(btn1BgColor)
        setSummaryParagraph(summaryParagraph)
        setOpacityValueLow(opacityValue)
        setComparisonScreen(comparisonScreen)
        setFullWidth(fullWidth)
        setFooterButtonEnable(footerButtonEnable)
        setGradientButton(gradientButton)
        setLargeImage(largeImage)
        setAllButtonsDisable(allButtonsDisable)
        setBtn1TextColor(btn1TextColor)
        setFooterText(footerText)

    }

    //without button card
    const footerContent = () => {
        return (
            <FooterContent highlightText={
                <p className='text-white md:w-[295px]'>{t('Most_of_Your')}
                    <span className='text-[#94C3E8]'>{" "}{t('Kudzu+')}
                    </span>{" "}{t('Membership')}.</p>
            }
                isSpace={true}
                type ={'extendFlow'}
                subHeaderText="Learn about your exclusive features."
                image={KudzuPluseLogo} buttonEnabled={true} gradientBorder={true}
                buttonText="Explore Kudzu+"
                footerBtnAction={() => {
                    showAlertModalPlus(true, '', '', "", true, true, '', t('Learn_More'), true, '',
                        <CustomCarousel  slidesData={slidesDataForFeatureCarousel} onCancelBtnClickPlusModal={onCancelBtnClickPlusModal}
                          />,
                        true, "", "", true, "", false, false, false, false, true);
                }}
                borderDirection={'even'}
                isSubheadingwidth={false}
                largeImage={true}
            />
        )

    }


    const closeModelPlus = () => {
        setShowCarouselScreensShow(false);
        logFirebaseEvents("ManageMembershipCancelation", "Close_clicked", "Close_clicked", "", "");
        setShowPlusModal(false)
    }
    const onAcptBtnClickPlusModal = () => {
        if (btn1Text === t('setup_direct_deposit')) {
            navigate("/AccountServices/Spending/ManageDirectDeposit");
        }
        else if (btn1Text === t('enroll_in_savings') ) {
            navigate("/SetupSavingsAccount");
        }
        else if(btn1Text === t('goto_savings')){
          navigate("/Savings");
        }
        else if (btn1Text === t('get_covered')) {
            navigate("/Climb/ClimbMenu");
        }

        else if (btn1Text === t('create_savings_goal')) {
            navigate("/Climb/ClimbMenu");
        }

        else if (btn1Text === t('findATMBtn')) {
            navigate("/Help/FindATM");
        }

        else {
            logFirebaseEvents("ManageMembershipCancelation", "downgrade_to_kudzu_Clicked", "downgrade_to_kudzu_Clicked", "", "");
            navigate("/kudzuplusSecurity", { state: { type: t('downgrad_to_kudzu_plus') } });
        }

    }

    const onCancelBtnClickPlusModal = () => {
        logFirebaseEvents("ManageMembershipCancelation", "Cancel_clicked", "Cancel_clicked  ", "", "");
        setIsLoading(true)
        setTimeout(() => {
        setIsLoading(false)
        setShowPlusModal(false)
        navigate("/home");
        }, 1000);
    }

    const handleTermsClick = () =>{
        if (accessTokenToApi == undefined || accessTokenToApi == null) {
          return;
      }
      else {
          navigate('/Documents/Policies/Covered%20by%20Kudzu%20Terms%20and%20Conditions', { state: { name: 'Covered by Kudzu Terms and Conditions', 
            url:
            userMembershipData?.membershipType === "Plus" ||
            userMembershipData?.membershipType === "Trial"
            ? "CoveredByKudzuPlusTerms"
            : "CoveredByKudzuTerms", accType: 64, CardKey: cards?.[0]?.CardKey } });
      
      }
      }

    const hasSavingsAccount = cards?.some(item => item.AccountTypeName === "Savings");

    const slidesDataForFeatureCarousel = [
        {
            heading: <div><p className='text-[#94C3E8]'>Let’s keep growing!</p>
                <p className='w-[400px]'>Explore all the features and benefits Kudzu+ has to offer.</p></div>,
            paragraph: '',
            imageUrl: require('../../../assets/kudzu-plus-images/add-even-new.png'),
            carouselAcceptBtnText: '',
            carouselCancelBtnText: 'Back to Home',
            carouselCancelBtnClick: onCancelBtnClickPlusModal,
            footerTextForUpgrade: t("first_three_months_charged_automatically"),
            dynamicfooterStyles: "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
        },
        {
            heading: addLineBreaks(t('Access_Direct_Depo_explore_carousel')),
            paragraph: '',
            videoUrl: require('./../../../assets/videos/freeTrailVideos/kudzu-plus-ach.mp4'),
            carouselAcceptBtnText: 'Set up Direct Deposit',
            carouselCancelBtnText: 'Back to Home',
            carouselCancelBtnClick:onCancelBtnClickPlusModal,
            carouselAcceptBtnClick:()=>{navigate("/AccountServices/Spending/ManageDirectDeposit")},
            footerTextForUpgrade: t("Access_Direct_footer_explore_carousel"),
            dynamicfooterStyles: "font-hanken-grotesk w-[455px] mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
        },
        {
            heading:addLineBreaks(t('save_with_explore_carousel')),
            paragraph: <p>{t("plan_future_para")}{" "}
            <span
             className="!text-[#94C3E8] lg:text-[17px] cursor-pointer relative inline-block"
             onClick={(e) => {
               e.stopPropagation();
               const tooltip = e.currentTarget.querySelector('.tooltip');
               if (!tooltip) return;
        
               const isVisible = tooltip.style.display === 'block';
               tooltip.style.display = isVisible ? 'none' : 'block';
        
               // Close the second tooltip if it's open
               const tooltipAPY = e.currentTarget.closest('p').querySelector('.tooltipAPY');
               if (tooltipAPY && tooltipAPY.style.display === 'block') {
                 tooltipAPY.style.display = 'none';
               }
        
               if (!isVisible) {
                 const handleClickOutside = (event) => {
                   if (tooltip && !tooltip.contains(event.target)) {
                     tooltip.style.display = 'none';
                     document.removeEventListener('click', handleClickOutside);
                   }
                 };
                 setTimeout(() => {
                   document.addEventListener('click', handleClickOutside);
                 }, 0);
               }
             }}

            >
                 {addLineBreaks(t("Saving"))}  
                 <div
                          className={`tooltip hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
                            p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
                            shadow-lg z-10 cursor-pointer transition-all duration-1000`}
                        >
                          <div className="tooltip-arrow-comparion"></div>
                          <span className="text-[14px]">{t('Savings_Goals')}</span> {t('SavingGoal_Tooltip')}
                        </div>
            </span>
            <br></br>
              <span
                    className="!text-[#94C3E8] lg:text-[17px] cursor-pointer relative inline-block"
                  >
                    {addLineBreaks(t("Goal"))}  
                    <div
                      className={`tooltip hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
                        p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
                        shadow-lg z-10 cursor-pointer transition-all duration-1000`}
                    >
                      <div className="tooltip-arrow-comparion"></div>
                      <span className="text-[14px]">{t('Savings_Goals')}</span> {t('SavingGoal_Tooltip')}
                    </div>
                  </span>{" "}
            {" "}{t("para_saving_goals_sec_part")}{" "}
            <span
                className="!text-[#94C3E8] cursor-pointer relative inline-block"
            onClick={(e) => {
                e.stopPropagation();
                const tooltips = e.currentTarget.querySelector('.tooltipAPY');
                if (!tooltips) return;
         
                const isVisibleAPY = tooltips.style.display === 'block';
                tooltips.style.display = isVisibleAPY ? 'none' : 'block';
         
                // Close the first tooltip if it's open
                const tooltip = e.currentTarget.closest('p').querySelector('.tooltip');
                if (tooltip && tooltip.style.display === 'block') {
                  tooltip.style.display = 'none';
                }
         
                if (!isVisibleAPY) {
                  const handleClickOutside = (event) => {
                    if (tooltips && !tooltips.contains(event.target)) {
                      tooltips.style.display = 'none';
                      document.removeEventListener('click', handleClickOutside);
                    }
                  };
                  setTimeout(() => {
                    document.addEventListener('click', handleClickOutside);
                  }, 0);
                }
              }}
            >
                {t("para_saving_goals_third_part")}
                 <div
                           className={`tooltipAPY hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
                             p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
                             shadow-lg z-10 cursor-pointer transition-all duration-1000`}
                         >
                           <div className="tooltip-arrow-comparion"></div>
                           <strong className="text-[12px]">{t('APY')}</strong> {t('APY_Saving_goal')}
                         </div>
                </span>
            </p>,
            dynamicSubHeaderStyles:"sm:w-[396px] font-hanken-grotesk modal-title text-white lg:text-[16px] md:text-[14px] sm:text-[10px] text-[12px]  font-[300]",
            videoUrl: require('./../../../assets/videos/freeTrailVideos/Set_Intentions.mp4'),
            carouselCancelBtnText: 'Back to Home',
            carouselAcceptBtnText: hasSavingsAccount ? "Go to Savings": 'Enroll in Savings',
            carouselCancelBtnClick:onCancelBtnClickPlusModal,
            carouselAcceptBtnClick: () => {
              navigate(hasSavingsAccount ? "/Savings" : "/SetupSavingsAccount")
          },
            footerTextForUpgrade: t("savings_intention"),
            dynamicfooterStyles: "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
        },
        // {
        //     heading:addLineBreaks(t('Earn_account_balance')),
        //     paragraph: '',
        //     videoUrl: require('./../../../assets/videos/freeTrailVideos/Savings_APY.mp4'),
        //     carouselAcceptBtnText: 'Enroll in Savings',
        //     carouselCancelBtnText: 'Cancel',
        //     carouselCancelBtnClick:onCancelBtnClickPlusModal,
        //     carouselAcceptBtnClick:() => {navigate("/Savings")},
        //     footerTextForUpgrade: t("savings_intention"),
        //     dynamicfooterStyles: "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
        // },
        {
            heading:addLineBreaks(t('cover_insufficient_funds')),
            paragraph: '',
            imageUrlAlter: require('../../../assets/kudzu-plus-images/overdraft_imag.png'),
            carouselAcceptBtnText: 'Get Covered',
            carouselCancelBtnText: 'Back to Home',
            carouselCancelBtnClick:onCancelBtnClickPlusModal,
            carouselAcceptBtnClick:() => {navigate("/Climb/ClimbMenu")},
            footerTextForUpgrade: <>{t("covered_by_kudzu_climb_footer_new_updated")} <span className="underline cursor-pointer" onClick={handleTermsClick}>{t('kudzu_navigate_link')}</span></>,
            dynamicfooterStyles: "font-hanken-grotesk w-[454px] mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
        },
        // {
        //     heading: addLineBreaks(t('work_toward_unique_savings')),
        //     paragraph: '',
        //     videoUrl: require('./../../../assets/videos/freeTrailVideos/Set_Intentions.mp4'),
        //     getstartTrue: true,
        //     carouselAcceptBtnText: 'Create a Savings Goal',
        //     carouselCancelBtnText: 'Cancel',
        //     carouselCancelBtnClick:onCancelBtnClickPlusModal,
        //     carouselAcceptBtnClick:() =>{navigate("/Climb/ClimbMenu")},
        //     footerTextForUpgrade: t("matter_savings_intention"),
        //     dynamicfooterStyles: "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]",
        //     dynamicHeaderStyles:"font-serif-pro modal-title w-[400px] lg:text-[31px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal"

        // },
        {
            heading: addLineBreaks(t('Save_On_Out_Of_NetWork_Atm')),
            paragraph: '',
            videoUrl: require('./../../../assets/videos/freeTrailVideos/kudzu-plus-atm.mp4'),
            getstartTrue: true,
            carouselAcceptBtnText: 'Find an ATM',
            carouselCancelBtnText: 'Back to Home',
            carouselCancelBtnClick:onCancelBtnClickPlusModal,
            carouselAcceptBtnClick:() =>{navigate("/Help/FindATM")},
            footerTextForUpgrade: t("free_atm_footer"),
            dynamicfooterStyles: "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]"
        },
    ];




    const handleFeatutesModal = (caseType) => {
        let title, description, primaryBtnText, secondaryBtnText, imageSrc, videoSrc, footerTextModal, dynamicfooterStylesModal;

        switch (caseType) {
            case "achAccess":
                title = '';
                description = t('Access_individual_head_one');
                primaryBtnText = t('setup_direct_deposit');
                secondaryBtnText = t('back_to_home_individual');
                imageSrc = false;
                // footerTextModal =  t("receive_direct_depo_footer")
                // dynamicfooterStylesModal =  "font-hanken-grotesk w-[452px] mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]";
                videoSrc = require('./../../../assets/videos/freeTrailVideos/kudzu-plus-ach.mp4');
                footerTextModal = t("Access_Direct_footer_explore_carousel");
                dynamicfooterStylesModal =  "font-hanken-grotesk w-[455px] mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]";
                break;

            case "savingsInteresrRate":
                // title = '';
                title =
                <p>
                      {t("plan_future_para")}
                      <span
                        className="!text-[#94C3E8] lg:text-[17px] cursor-pointer relative inline-block"
                        onClick={(e) => {
                          e.stopPropagation();
                          const tooltip = e.currentTarget.querySelector('.tooltip');
                          if (!tooltip) return;
                   
                          const isVisible = tooltip.style.display === 'block';
                          tooltip.style.display = isVisible ? 'none' : 'block';
                   
                          // Close the second tooltip if it's open
                          const tooltipAPY = e.currentTarget.closest('p').querySelector('.tooltipAPY');
                          if (tooltipAPY && tooltipAPY.style.display === 'block') {
                            tooltipAPY.style.display = 'none';
                          }
                   
                          if (!isVisible) {
                            const handleClickOutside = (event) => {
                              if (tooltip && !tooltip.contains(event.target)) {
                                tooltip.style.display = 'none';
                                document.removeEventListener('click', handleClickOutside);
                              }
                            };
                            setTimeout(() => {
                              document.addEventListener('click', handleClickOutside);
                            }, 0);
                          }
                        }}
                      >
                        {addLineBreaks(t("Saving"))}  
                        <div
                          className={`tooltip hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
                            p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
                            shadow-lg z-10 cursor-pointer transition-all duration-1000 leading-snug`}
                        >
                          <div className="tooltip-arrow-comparion"></div>
                          <span className="text-[14px]">{t('Savings_Goals')}</span> {t('SavingGoal_Tooltip')}
                        </div>
                      </span>{" "}
                      <br></br>
                      <span
                        className="!text-[#94C3E8] lg:text-[17px] cursor-pointer relative inline-block"
                      >
                        {addLineBreaks(t("Goal"))}  
                        <div
                          className={`tooltip hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
                            p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
                            shadow-lg z-10 cursor-pointer transition-all duration-1000`}
                        >
                          <div className="tooltip-arrow-comparion"></div>
                          <span className="text-[14px]">{t('Savings_Goals')}</span> {t('SavingGoal_Tooltip')}
                        </div>
                      </span>{" "}
                      {t("para_saving_goals_sec_part")}{" "}
                      <span
                        className="!text-[#94C3E8] cursor-pointer relative inline-block"
                        onClick={(e) => {
                          e.stopPropagation();
                          const tooltips = e.currentTarget.querySelector('.tooltipAPY');
                          if (!tooltips) return;
                   
                          const isVisibleAPY = tooltips.style.display === 'block';
                          tooltips.style.display = isVisibleAPY ? 'none' : 'block';
                   
                          // Close the first tooltip if it's open
                          const tooltip = e.currentTarget.closest('p').querySelector('.tooltip');
                          if (tooltip && tooltip.style.display === 'block') {
                            tooltip.style.display = 'none';
                          }
                   
                          if (!isVisibleAPY) {
                            const handleClickOutside = (event) => {
                              if (tooltips && !tooltips.contains(event.target)) {
                                tooltips.style.display = 'none';
                                document.removeEventListener('click', handleClickOutside);
                              }
                            };
                            setTimeout(() => {
                              document.addEventListener('click', handleClickOutside);
                            }, 0);
                          }
                        }}
                      >
                        {t("para_saving_goals_third_part")}
                        <div
                          className={`tooltipAPY hidden w-[174px] font-[400] absolute left-1/2 -translate-x-1/2 top-[100%] mt-2
                            p-[16px] bg-[#3C66FF] text-white text-[12px] rounded-xl
                            shadow-lg z-10 cursor-pointer transition-all duration-1000 leading-snug`}
                        >
                          <div className="tooltip-arrow-comparion"></div>
                          <strong className="text-[12px]">{t('APY')}</strong> {t('APY_Saving_goal')}
                        </div>
                      </span><span>.</span>
                    </p>;
                description = <p className='md:!w-[409px]'>{t("heading_saving_goals")}</p>;
                // description = <p>{t("plan_future_para")}<span className='text-[#94C3E8]'>{t("para_saving_goals")}</span>{t("para_saving_goals_sec_part")}<span className='text-[#94C3E8]'>{t("para_saving_goals_third_part")}</span></p>
                primaryBtnText = hasSavingsAccount ? t('goto_savings') : t('enroll_in_savings');
                secondaryBtnText = t('back_to_home_individual');
                imageSrc = false;
                footerTextModal =  t("savings_intention");
                dynamicfooterStylesModal = "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]";
                // videoSrc = require('./../../../assets/videos/freeTrailVideos/Savings_APY.mp4');
                videoSrc = require('./../../../assets/videos/freeTrailVideos/Set_Intentions.mp4');
                break;
            //new change
            case "coveredByKudzuPlus":
                title = '';
                description = <p className='lg:text-[30px]'>{t('cover_insufficient_funds_Update')}</p>
                primaryBtnText = t('get_covered');
                secondaryBtnText = t('back_to_home_individual');
                imageSrc = require('../../../assets/kudzu-plus-images/overdraft_imag.png');
                footerTextModal = <>{t("covered_by_kudzu_climb_footer_new_updated")} <span className="underline cursor-pointer" onClick={handleTermsClick}>{t('kudzu_navigate_link')}</span></>;
                dynamicfooterStylesModal = "font-hanken-grotesk w-[454px] mt-[42px] modal-title text-[#94C3E8] text-[10px] font-[400]"
                videoSrc = false;
                break;

            case "savingsGoals":
                title = '';
                description = t('work_toward_unique_savings');
                primaryBtnText = t('create_savings_goal');
                secondaryBtnText = t('back_to_home_individual');
                imageSrc = false;
                footerTextModal = t("matter_savings_intention");
                dynamicfooterStylesModal = "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]";
                videoSrc = require('./../../../assets/videos/freeTrailVideos/Set_Intentions.mp4');
                break;

            case "ATMWithdrawals":
                title = '';
                description = t('ATM_New_Text');
                primaryBtnText = t('findATMBtn');
                secondaryBtnText = t('back_to_home_individual');
                imageSrc = false;
                footerTextModal = t("free_atm_footer");
                dynamicfooterStylesModal = "font-hanken-grotesk mt-[42px] modal-title text-[#94C3E8] text-[12px] font-[400]";
                videoSrc = require('./../../../assets/videos/freeTrailVideos/kudzu-plus-atm.mp4');
                break;

            default:
                console.error("Invalid case type");
                return;
        }


        showAlertModalPlus(true, title, description, title, true, true, primaryBtnText, secondaryBtnText, true, imageSrc,
            videoSrc ? <video className="block m-auto" alt="video" style={{ maxHeight: "300px", maxWidth: "300px", background: "transparent" }} autoPlay muted loop preload="auto" playsInline> <source src={videoSrc} type="video/mp4" /> </video> : '',
            true, "#262B3A", '', true, '', false, true, true, true, false,'#FFFFFF',<><p className={dynamicfooterStylesModal}>{footerTextModal}</p></>
        );
    };

 

    const features = [
        {
            icon: Ach_acces,
            text: "2 Day Early ACH Access",
            endIcon: Checkbox,
            id: "achAccess"
        },
        {
            icon: SavingsInteresrRate,
            text: "1.26% Annual Percentage Yield (APY)",
            endIcon: hasSavingsAccount ? GradientArrow :  Security,
            id: "savingsInteresrRate"
        },
        {
            icon: CoveredbyKudzuplus,
            text: "Covered by Kudzu+",
            endIcon: Checkbox,
            id: "coveredByKudzuPlus"
        },
        {
            icon: Frame,
            text: "Savings Goals",
            endIcon: Checkbox,
            id: 'savingsGoals'
        },
        {
            icon: ATM_small,
            text: "No Out-of-Network ATM Withdrawal Fees",
            endIcon: GradientArrow,
            id: 'ATMWithdrawals'
        }
    ];

    const gradientIconLength = features?.filter((gradientIcon) => gradientIcon?.endIcon === GradientArrow)?.length



    const handleNavigateTolearnMore = () => {
        const currentPath = { currentPathFromStore: location.pathname };
        dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
        if (userMembershipData?.extendTrial){
            logFirebaseEvents("ManageMembership", "Extend_kudzu_Clicked", "Extend_kudzu_Clicked", "", "");
            setShowCarouselScreensShow((prev) => !prev);
            // showAlertModalPlus(true, t("thanks"), t("Try_a_Kudzu+_membership_for_three_months"), "", true, true, t('Learn_More'), t('No_Thanks'), true, require('./../../assets/kudzu-plus-images/kudzu-plus-logo.png') ,"",true,"#262B3A",t('first_three_months_charged_automatically'),true,'',false,false,true,true);
            const data = { kudzuFlowFrom: "fromExtendFlow" };
            dispatch({ type: 'KUDZU_PLUS_FROM', payload: data });
        }
        else {
            debugger;
            logFirebaseEvents("ManageMembership", "Explore_Features_&_Benefits_Clicked", "Explore_Features_&_Benefits_Clicked", "", "");
            showAlertModalPlus(true, '', '', "", true, true, '', t('Learn_More'), true, '', <CustomCarousel slidesData={slidesDataForFeatureCarousel} onCancelBtnClickPlusModal={onCancelBtnClickPlusModal} finalButtontextChange={t('done')} dotsAbove={true} forClimbBtn={true} forClimbHomeBtn={true} />, true, "", "", true, "", false, false, false,false,true);
        }
    }

    const [comparisonClickFrom, setComparisonClickFrom] = useState("");
    const [promoKey, setPromoKey] = useState(loggedResponse?.Promos?.[0]?.PromoKey);
    const [selectedType, setSelectedType] = useState(location.state?.type);
    const [show2faSelection, setshow2faSelection] = useState(false);

    const handleFeatutes = (fromClick)=>{
      setComparisonClickFrom(fromClick)
      showAlertModalPlus(true, '', promoKey == PAID_PROMO_KEY || userMembershipData?.extendTrial ? t('access_exclusive_features_and_benefits_with_kudzu_membership') : t('Access_exclusive_features_and_benefits'), "", false, false, '', '', false, '', "", true, "", "", true, <ComparisonOffer handleComparisonScreen={handlOkComparison} />, true, false);
     }

     const handlOkComparison = () =>{
      setSelectedType(t('upgrade_to_kduzu_plus'))
      setShowPlusModal(false)
      setshow2faSelection(true)
  }

   const acceptHandleForClimb = () =>{
      showAlertModalPlus(false)
      setLoading(true) 
      setTimeout(() => {
        // showAlertModalPlus(true, '', promoKey == PAID_PROMO_KEY ? t('access_exclusive_features_and_benefits_with_kudzu_membership') : t('Access_exclusive_features_and_benefits'), "", false, false, '', '', false, '', "", true, "", "", true, <ComparisonOffer handleComparisonScreen={isSignUpAccept} />, true, false);
           showAlertModalPlus(true, '', promoKey == PAID_PROMO_KEY || userMembershipData?.extendTrial === true ? t('access_exclusive_features_and_benefits_with_kudzu_membership') : t('Access_exclusive_features_and_benefits'), "", false, false, '', '', false, '', "", true, "", "", true, <ComparisonOffer handleComparisonScreen={isSignUpAccept} isKudzuPlus={true}/>, true, false);
        setLoading(false)
      }, 1000);
      logFirebaseEvents("Membership_Enrollment", "Kudzu_Plus_Begin_Free_Trial_Clicked", "Kudzu_Plus_Begin_Free_Trial_Clicked", "", "");
    }
    

    const handleCancelMembership = () => {
        logFirebaseEvents("ManageMembershipCancelation", "Cancel_Kudzu+_Membership_Clicked", "Cancel_Kudzu+_Membership_Clicked", "", "");
        const currentPath = { currentPathFromStore: location.pathname };
        dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });

        const modalContent = userMembershipData?.membershipType === "Plus"
        ? (<p>{t("KudzuPlus_Cancellation_SubHeading")}</p>)
        : (
            <p className='font-[300]'>
                {t("By_Cancelling")}
                <span
                    className='font-bold'
                    onClick={acceptHandleForClimb}
                    style={{ cursor: 'pointer' }}
                >
                    {t("Kudzu_update_link")}
                </span>
            </p>
        ); 
        showAlertModalPlus(true, t("thanks"), t("Do_you_want_to_downgrade_to_Kudzu"),
        modalContent
        , true, true, t('Downgrade_to_Kudzu'), t('Cancel'), true, require('./../../../assets/kudzu-plus-images/KudzuPluseLogo.png'), "", true, "#262B3A", '', true, '', false, true, false, true, false);
    }

    const extendFlowCloseCallbackFunction = (val) =>{
        setShowCarouselScreensShow(val)
    }

        const handleComparisonBackClick = () =>{
          navigate("/home")
     }
    
     
     const headingContent = userMembershipData?.membershipType === "Plus"
     ? addLineBreaks(t("Take_advantage_of_your_Kudzu+_membership"))
     : userMembershipData?.membershipType === "Trial"
     ? addLineBreaks(t("Take_advantage_of_your_Kudzu+_trial"))
     : "";

    return (

        <HomeLayout>

            <HomeHeader heading={headingContent} isHeaderCaption={true} />
            {showCarouselScreenShow &&
                <MemnershipEnrollmentScreens extendFlowCloseCallbackFunction = {extendFlowCloseCallbackFunction} />}
            <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%]    animate__animated animate__fadeInRight '>
                <DynamicCard
                    header={false}
                    footer={true}
                    CardRadius={true}
                    HeaderRadius={true}
                    cardWidth={width.homeCard}
                    isWhite={appThemeData.isWhiteBgForCard}
                    isDarkForKudzu={appThemeData.isDarkBgForCard}
                    backgroundColor={'--cardHeading-bg'}
                    HeaderContent={
                        <>
                            <CardHeading heading={t('Kudzu+')} imageEnd={true} image={Approved} />
                        </>
                    }
                >

                    <div className='sm:mx-0 mx-4 md:mt-20 mt-16'>
                        <div className='flex justify-between text-white mb-6 font-hanken-grotesk font-semibold'>
                            <div className='uppercase tracking-[4px]'>activE features</div>
                            <div>{gradientIconLength + " "  + '/' + "  " + features?.length}</div>
                        </div>

                        <ProgressBar filledbgColor={"linear-gradient(109.08deg, #2965FB 12.11%, #4B70B9 57.56%, #30BC89 102.11%)"} unfilledBg={"#324261"} progressBarWidth={"100%"} progressBarHeight={"6px"} progress={gradientIconLength * 20} />
                    </div>

                    <div className='flex flex-col justify-center mt-10 items-center sm:mx-0 mx-4 mb-10'>
                        <div className='w-[90%] text-white'>

                            <div className="flex flex-col gap-14 mt-4">
                                {features.map((feature, index) => (
                                    <div key={index} className="flex justify-between items-center cursor-pointer">
                                        <div className="flex items-center gap-4" onClick={() => handleFeatutesModal(feature.id)}>
                                            <img src={feature.icon} alt={feature.text} />
                                            <p className="font-bold font-hanken-grotesk md:text-[15px] sm:text-[13px] uppercase tracking-[4px]">{feature.text}</p>
                                        </div>
                                        <img src={feature.endIcon} alt={feature.endIcon} onClick={() => feature.endIcon === GradientArrow ? handleFeatutesModal(feature.id) : ""} />
                                    </div>
                                ))}
                            </div>

                            <div className='mt-8 flex items-center flex-col justify-center'>
                                {userMembershipData?.extendTrial && (
                                    <>
                                        <button
                                            type="button"
                                            onClick={handleNavigateTolearnMore}
                                            className="flex items-center justify-center rounded-full md:w-[37%] w-full h-[45px] bg-gradient-to-r from-[#2965FB] via-[#4B70B9] to-[#30BC89] p-[4px] text-white lg:text-[16px] md:text-[18px] sm:text-[11px] text-[14px] leading-[13px] md:leading-[26px] font-[700] font-hanken-grotesk"
                                            data-te-ripple-init
                                        >
                                            <div className="flex h-full text-[12px] md:text-[14px] items-center justify-center rounded-full w-full bg-[#2C3449]">
                                                {t('Extend_Membership')}
                                            </div>
                                        </button>

                                        <div
                                            className="text-[#94C3E8] font-normal font-hanken-grotesk mt-4"
                                        >
                                            <span>{userMembershipData?.daysRemaining}</span>&nbsp;Days Remaining
                                        </div>
                                    </>
                                )}

                                {(!userMembershipData?.extendTrial && userMembershipData?.membershipType === "Plus") && <button type='button' onClick={handleCancelMembership} className='text-[#94C3E8] font-normal font-hanken-grotesk underline mt-4'
                                >{t("Cancel_Kudzu_membership")}</button>}
                            </div>
                            <div>
  {userMembershipData?.membershipType === 'Trial' && (
<div className="flex items-center justify-between space-x-4 mt-4">
 <p>
  {t('trail_ends')} {new Date(loggedResponse.Subscription.TrailEndDate).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric'
  })}
</p>

<button
        type="button"
        onClick={handleCancelMembership}
        className="ml-6 text-[#94C3E8] font-normal font-hanken-grotesk"
        style={{marginRight:"-20%"}}
>
        {t("Cancel_Kudzu_Trial_membership")}
</button>
<button
        type="button"
        className="flex items-center justify-center rounded-full w-[210px] h-[55px] bg-gradient-to-r from-[#2965FB] via-[#4B70B9] to-[#30BC89] p-[2px] text-white text-[14px] leading-[13px] font-[700] font-hanken-grotesk"
        data-te-ripple-init
>
<div className="flex h-full items-center justify-center rounded-full w-full bg-[#2C3449] text-[14px]">
<span className=''>{loggedResponse.Subscription.TrailRemainingDaysText}</span> &nbsp;  Remaining
</div>
</button>
</div>
  )}
</div>
                        </div>
                    </div>

                    {loading && <Loader />}
                </DynamicCard>
                {footerContent()}

            </div>
            <CustomAlertModel isOpen={showModel}
                modalBg={!isSubFooter && 'bg-[#E4F1EB]'}
                btn1BorderColor={!isSubFooter && '#30BC89'}
                btn1TextColor={!isSubFooter && '#FEFAEE'}
                btn1BrExist={!isSubFooter && true}
                btn2TextColor={!isSubFooter && '#559C7E'}
                btn1BgColor={!isSubFooter && '#30BC89'}
                onClose={closeCustomAlertModal}
                image={modelImage}
                highlightMsg={<p className={`${HighlightMsgStyles} sm:flex block flex-col`}>{highlightMsg}
                    <span className={`${HeaderMsgStyles} ${savingsTheme ? 'text-[#0C4437]' : 'text-[#0C4437]'}`}> {headerMsg}</span></p>}
                subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text} btn2Text={btn2Text}
                btn1TypeAcpt={btn1TypeAcpt}
                verificationFailure={() => { }}
                footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
                onAcptBtnClick={onAcptBtnClick}
                onCancelBtnClick={onCancelBtnClick}
                isBorderNone={isBorderNone}
                subFooter={isSubFooter && subComponent()}
            />


            <CustomModalPlus isOpen={showPlusModal} onClose={closeModelPlus}
            onBack={() => {
              if (comparisonClickFrom == 'cancelledSuccesfully') {
                  handleComparisonBackClick()
              } else {
                  closeModelPlus()
              }

          }}
                image={modelImage}
                carousel={carousel}
                isBorderNone={isBorderNone}
                highlightMsg={<p className={HeaderMsgStylesForPlus}><span className='text-[#94C3E8] font-serif-pro'>{btn1Text === t('Downgrade_to_Kudzu') ? t('are_you_sure') : ""}</span><span>{headerMsg}</span></p>}
                subHeaderMsg={<p className={SubHeaderMsgPlusStyles}>{subHeaderMsg}</p>}
                btn1Exists={btn1Exists}
                borderGradientrouneded={true}
                btn1TextColor={btn1TextColor ? btn1TextColor : '#94C3E8'}
                btn2TextColor={'#779CE5'}
                borderWhite={'2px solid #94C3E8'}
                btn2Exists={btn2Exists}
                btn1Text={btn1Text}
                btn1BgColor={btn1BgColor}
                btn2Text={btn2Text}
                opacityLow={opacityValueLow}
                defaultCornerRadius={false}
                btn1TypeAcpt={btn1TypeAcpt}
                onAcptBtnClick={onAcptBtnClickPlusModal}
                onCancelBtnClick={onCancelBtnClickPlusModal}
                gradientButton={gradientButton}
                largeImage={largeImage}
                allButtonsDisable={allButtonsDisable}
                footerText={footerText}
                comparisonScreen={comparisonScreen}
                fullWidth={fullWidth} 
            />

            {isLoading && <Loader />}
        </HomeLayout>


    )
}

export default ManageMembershipKudzuPlus;
